import ServicesNavbar from './ServicesNavbar';

import { connect } from 'react-redux';
import { getUsers } from '@src/redux/modules/entities';
import * as qs from 'utils/querystring';

const mapStateToProps = (state, ownProps) => {
  const { userId } = ownProps;

  const users = getUsers(state);
  const user  = users[userId];

  return { user };
}

export default connect(mapStateToProps, {})(ServicesNavbar);



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/components/ServicesNavbar/ServicesNavbarContainer.js